import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    homeSwiperOption:{
      activeIndex:-1,
      swiperChangeState:"end"
    },
  },
  mutations: {
    setHomeSwiperOption: (state, payload) => {
      // console.log("原始值：",state);
      // console.log("新值：",payload);
      state.homeSwiperOption=payload.homeSwiperOption;
      
    },
  },
  actions: {
    setHomeSwiperOptionAsync: (context, payload) => {
      context.commit('setHomeSwiperOption', payload);
    },
  },
  modules: {
  }
})
